import { render } from "./addPerson.vue?vue&type=template&id=7839e10e&scoped=true"
import script from "./addPerson.vue?vue&type=script&lang=js"
export * from "./addPerson.vue?vue&type=script&lang=js"

import "./addPerson.vue?vue&type=style&index=0&id=7839e10e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7839e10e"]])

export default __exports__